import React from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';

import SettingsBlock from './components/settingsBlock';
import Logo from './components/Logo';
import Menu from './components/Menu';
import './Header.scss';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuth: false,
      vendorType: false,
      scrolling: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    this.setState({
      isAuth: this.props.isAuthorized,
      vendorType: this.props.user.vendorType
    })
  }

  componentWillReceiveProps(next) {
    this.setState({
      isAuth: next.isAuthorized,
      vendorType: next.user.vendorType
    })
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  static propTypes = {
    isAuthorized: PropTypes.bool,
    user: PropTypes.object,
    showLogin: PropTypes.func,
    showRegister: PropTypes.func,
    submitLogout: PropTypes.func,
    setToggleFalse: PropTypes.func,
    cart: PropTypes.array,
    onMainClick: PropTypes.bool,
  };

  handleScroll() {
    if (window.pageYOffset !== 0 && this.state.scrolling === false) {
      this.setState({scrolling: true});
    }
    else if (window.pageYOffset === 0 && this.state.scrolling === true) {
      this.setState({scrolling: false});
    }
  }

  render() {

    const {
      isAuth,
      vendorType,
    } = this.state;

    const {
      user,
      showLogin,
      showRegister,
      submitLogout,
      setToggleFalse,
      onMainClick,
      cart,
    } = this.props;

    const className = classes('header-wrap wrapper', {fixed: this.state.scrolling});

    return (
      <header
        className={className}
        onScroll={() => this.handleScroll()}
      >
        <div className="header">
          <Logo
            setToggleFalse={setToggleFalse}
          />


          <div className="header__group">
            {
              vendorType === 'tour' ?
                (
                  <div className="header__user-info">
                    <span>Welcome back</span>
                    <span>
                      {`${user.name} ${user.lastName}`}
                    </span>
                  </div>
                ) : null
            }
            <div className="header__block">
              <Menu
                cart={cart}
                user={user}
              />
              <SettingsBlock
                isAuth={isAuth}
                vendorType={vendorType}
                showLogin={showLogin}
                showRegister={showRegister}
                submitLogout={submitLogout}
                user={user}
                onMainClick={onMainClick}
              />
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default Header;




// WEBPACK FOOTER //
// ./src/app/containers/Header/Component.js